module.exports = __webpack_public_path__ + "static/media/new-monkey.58b6a79e.png";